import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitogrishneshwarcab() {



  const cardData = {
    keyword: " Mumbai to Grishneshwar Cab",


"headingDescription": "Royal Route Cab offers reliable Mumbai to Grishneshwar cab service, providing safe, comfortable, and affordable pilgrimage travel for families, devotees, and group journeys. Grishneshwar Temple is one of the twelve sacred Jyotirlingas of Lord Shiva, located near Ellora Caves in Aurangabad district, approximately 300–330 km from Mumbai. Our professional drivers ensure a smooth, punctual, and stress-free journey through well-connected highways, making your spiritual trip convenient and peaceful. We offer flexible options including one-way drops, round trips, and customized pilgrimage packages covering nearby religious and heritage sites. Our fleet includes sedans, SUVs, Innova, Ertiga, Innova Crysta, and Tempo Travellers suitable for all group sizes. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for Mumbai to Grishneshwar cab service.",

"topPlaces": [
  {
    "title": "Grishneshwar Jyotirlinga Temple",
    "description": "Grishneshwar Jyotirlinga Temple is one of the twelve sacred Jyotirlingas dedicated to Lord Shiva and holds immense religious importance for Hindu devotees. The temple features beautiful red stone architecture, intricate carvings, and a spiritually powerful atmosphere. Devotees from across India visit this holy site for darshan, abhishek rituals, and spiritual fulfillment, making it the main attraction for pilgrims traveling from Mumbai."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves is a UNESCO World Heritage Site located very close to Grishneshwar Temple, featuring 34 rock-cut caves representing Hindu, Buddhist, and Jain traditions. The caves are famous for their stunning sculptures, ancient architecture, and the magnificent Kailasa Temple carved out of a single rock, attracting tourists and history lovers from all over the world."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Daulatabad Fort is a historic hilltop fortress known for its strong defense system and unique architectural design. It offers panoramic views and a glimpse into medieval Indian history, making it a popular stop for travelers visiting the Grishneshwar region."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Bibi Ka Maqbara, often called the Mini Taj Mahal, is a beautiful Mughal-era monument in Aurangabad built in memory of a queen. It is known for its elegant design, gardens, and resemblance to the Taj Mahal, attracting visitors for photography and sightseeing."
  },
  {
    "title": "Panchakki",
    "description": "Panchakki is a historical water mill in Aurangabad known for its unique engineering that uses underground water channels. It is an interesting attraction showcasing ancient technology and Mughal-era innovation."
  },
  {
    "title": "Aurangabad Caves",
    "description": "Aurangabad Caves are a group of ancient rock-cut Buddhist caves known for sculptures and carvings reflecting early Buddhist art. They are a quieter alternative to Ellora and Ajanta, offering peaceful exploration for history enthusiasts."
  },
  {
    "title": "Jayakwadi Dam",
    "description": "Jayakwadi Dam is one of the largest dams in Maharashtra, located near Aurangabad. It offers scenic views, birdwatching opportunities, and a peaceful environment for relaxation during travel."
  },
  {
    "title": "Khuldabad",
    "description": "Khuldabad is a historic town near Ellora known as the Valley of Saints, housing tombs of Sufi saints and the grave of Mughal Emperor Aurangzeb. It holds cultural and religious significance for visitors exploring the region."
  },
  {
    "title": "Shivaji Maharaj Museum Aurangabad",
    "description": "This museum showcases artifacts, weapons, and history related to Chhatrapati Shivaji Maharaj and the Maratha empire. It is an educational and cultural attraction for travelers interested in regional history."
  },
  {
    "title": "Ghrishneshwar Temple Surroundings",
    "description": "The surroundings of Grishneshwar Temple include small markets, local eateries, and devotional spaces where pilgrims can relax and explore after darshan. The area reflects a traditional spiritual environment combined with local culture and hospitality."
  }
],






services: [
  {
    name: "Mumbai to Grishneshwar Cab",
    description: "Mumbai to Grishneshwar cab service offers a comfortable and spiritual journey to one of the 12 Jyotirlingas in Maharashtra. Ideal for devotees and family trips, this service ensures smooth highway travel with experienced drivers. Well-maintained vehicles enhance comfort. It guarantees a peaceful and hassle-free pilgrimage experience."
  },
  {
    name: "Mumbai to Grishneshwar Taxi",
    description: "Mumbai to Grishneshwar taxi provides private and convenient transportation for long-distance religious travel. This service includes door-to-door pickup and flexible schedules. Suitable for families and groups. It ensures a smooth and reliable journey."
  },
  {
    name: "Mumbai to Grishneshwar Cab Service",
    description: "Mumbai to Grishneshwar cab service offers professional travel solutions with multiple vehicle options. This service is ideal for pilgrimage tours and long-distance travel. Clean vehicles and trained drivers ensure comfort. It ensures a safe and pleasant journey."
  },
  {
    name: "Mumbai to Grishneshwar Taxi Service",
    description: "Mumbai to Grishneshwar taxi service ensures dependable transportation with comfortable vehicles and experienced chauffeurs. This service is ideal for temple visits and religious tours. Flexible booking options enhance convenience. It guarantees a smooth journey."
  },
  {
    name: "Cab from Mumbai to Grishneshwar",
    description: "Cab from Mumbai to Grishneshwar offers a convenient way to travel between cities with complete comfort. This service is ideal for devotees preferring road travel. Professional drivers ensure safe journeys. It ensures a relaxed experience."
  },
  {
    name: "Taxi from Mumbai to Grishneshwar",
    description: "Taxi from Mumbai to Grishneshwar provides reliable long-distance travel for individuals and groups. This service ensures smooth highway journeys with experienced drivers. Comfortable seating enhances the experience. It guarantees a dependable ride."
  },
  {
    name: "Mumbai to Grishneshwar Cab Booking",
    description: "Mumbai to Grishneshwar cab booking allows customers to reserve their ride easily with flexible options. Travelers can choose vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Grishneshwar Taxi Booking Online",
    description: "Mumbai to Grishneshwar taxi booking online provides a quick and convenient way to plan your pilgrimage. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Mumbai to Grishneshwar Cab Price",
    description: "Mumbai to Grishneshwar cab price varies based on vehicle type, distance, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel expenses efficiently."
  },
  {
    name: "Mumbai to Grishneshwar Taxi Fare",
    description: "Mumbai to Grishneshwar taxi fare is designed to be affordable and transparent. Fare depends on route and vehicle selection. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Grishneshwar One Way Cab",
    description: "Mumbai to Grishneshwar one way cab offers cost-effective travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Mumbai to Grishneshwar Round Trip Taxi",
    description: "Mumbai to Grishneshwar round trip taxi provides complete travel solutions including return journeys. This service is ideal for devotees planning same-day or multi-day temple visits. Flexible schedules enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Grishneshwar Innova Cab",
    description: "Mumbai to Grishneshwar Innova cab is perfect for families and groups seeking spacious and comfortable travel. Premium seating and smooth performance enhance long journeys. It ensures a comfortable pilgrimage experience."
  },
  {
    name: "Mumbai to Grishneshwar Ertiga Cab",
    description: "Mumbai to Grishneshwar Ertiga cab offers affordable and spacious travel for small groups and families. Comfortable seating and good mileage make it ideal for long-distance journeys. It ensures a pleasant trip."
  },
  {
    name: "Mumbai to Grishneshwar Sedan Cab",
    description: "Mumbai to Grishneshwar sedan cab is ideal for individuals and small families seeking economical travel. Sedans offer smooth rides and comfort for long journeys. Professional drivers ensure safety. It ensures a relaxed journey."
  },
  {
    name: "Mumbai to Grishneshwar SUV Taxi",
    description: "Mumbai to Grishneshwar SUV taxi provides spacious and comfortable travel for groups. SUVs offer better performance and extra luggage space. Suitable for long-distance journeys. It ensures a comfortable travel experience."
  }
],

tableData: [
  ["Mumbai to Grishneshwar Cab", "Mumbai to Grishneshwar Taxi"],
  ["Mumbai to Grishneshwar Cab Service", "Mumbai to Grishneshwar Taxi Service"],
  ["Cab from Mumbai to Grishneshwar", "Taxi from Mumbai to Grishneshwar"],
  ["Mumbai to Grishneshwar Cab Booking", "Mumbai to Grishneshwar Taxi Booking Online"],
  ["Mumbai to Grishneshwar Cab Price", "Mumbai to Grishneshwar Taxi Fare"],
  ["Mumbai to Grishneshwar One Way Cab", "Mumbai to Grishneshwar Round Trip Taxi"],
  ["Mumbai to Grishneshwar Innova Cab", "Mumbai to Grishneshwar Ertiga Cab"],
  ["Mumbai to Grishneshwar Sedan Cab", "Mumbai to Grishneshwar SUV Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Grishneshwar Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Grishneshwar cab service, ideal for Jyotirlinga darshan and family travel."
  },
  {
    WhyChooseheading: "Experienced Pilgrimage Route Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced in temple and long-distance routes, ensuring safe driving and smooth travel."
  },
  {
    WhyChooseheading: "Perfect for Jyotirlinga Darshan",
    WhyChoosedescription: "Plan your Grishneshwar Jyotirlinga darshan conveniently with our reliable cab services for devotees and families."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel plans for Grishneshwar trips."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Grishneshwar cab service operates 24/7, allowing flexible departure anytime as per your schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Religious Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by devotees for Mumbai to Grishneshwar cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Grishneshwar cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Grishneshwar for one-way and round trips." },
  { question: "What is the distance between Mumbai and Grishneshwar?", answer: "The distance is approximately 330 to 360 km and takes around 7 to 9 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Grishneshwar cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Is this suitable for Jyotirlinga darshan?", answer: "Yes, our service is ideal for Grishneshwar Jyotirlinga pilgrimage trips." },
  { question: "Do you provide multi-day temple tours?", answer: "Yes, we provide customized multi-day darshan packages including nearby temples." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and religious occasions." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vijay Deshpande",
    feedback: "The Mumbai to Grishneshwar trip with Royal Route Cabs was very smooth and well-organized. The driver ensured a comfortable and safe pilgrimage journey throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Joshi",
    feedback: "Excellent experience for our Mumbai to Grishneshwar darshan. The cab was clean, the ride was comfortable, and the service was reliable for the entire trip.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Grishneshwar Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-grishneshwar-cab.jpg", // replace if needed
  "description": "Book Mumbai to Grishneshwar cab service with Royal Route Cabs for safe, reliable, and comfortable pilgrimage travel. Available for one-way and round-trip journeys with sedan, SUV, Innova, and Ertiga vehicles. 24x7 outstation taxi service to Grishneshwar Jyotirlinga.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7999", // approx starting package (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-grishneshwar-cab"
  }
};






  return (
    <div>

<Helmet>
  <title>Mumbai to Grishneshwar Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Grishneshwar cab with Royal Route Cabs. Safe and comfortable Jyotirlinga pilgrimage taxi service with sedan, SUV, Innova & Ertiga cars. 24x7 reliable travel."
  />

  <meta
    name="keywords"
    content="mumbai to grishneshwar cab, mumbai to grishneshwar taxi, mumbai to grishneshwar cab service, mumbai to grishneshwar taxi service, cab from mumbai to grishneshwar, taxi from mumbai to grishneshwar, mumbai to grishneshwar cab booking, mumbai to grishneshwar taxi booking online, mumbai to grishneshwar cab price, mumbai to grishneshwar taxi fare, mumbai to grishneshwar one way cab, mumbai to grishneshwar round trip taxi, mumbai to grishneshwar innova cab, mumbai to grishneshwar ertiga cab, mumbai to grishneshwar sedan cab, mumbai to grishneshwar suv taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/62.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitogrishneshwarcab;